import AllBase from "../components/AllBase";
import { ContractInfoMainnet } from "../contracts/DieAfter100HrsNft";

export default function MainnetAll() {
    return <AllBase contractInfo={ContractInfoMainnet} />;
}
